import React from 'react';
import { Select } from 'antd';
import { IconWrapper, SelectWithLabel } from './styles';
import Icon from '../assets/icons';
import { SortValue } from '../../api/responses';

type TSortSelect = {
  sortValue: SortValue;
  setSortValue: (value: SortValue) => void;
};

const SortSelect = ({ sortValue, setSortValue }: TSortSelect) => {
  const options = [
    { value: 'newest', label: 'Новые' },
    { value: 'oldest', label: 'Старые' },
    { value: 'date', label: 'Дата' },
    { value: 'name', label: 'Название' },
  ];

  const onSelect = (value: SortValue) => {
    setSortValue(value);
  };

  return (
    <SelectWithLabel>
      <Select
        prefix={
          <IconWrapper>
            <Icon variant='sort' />
          </IconWrapper>
        }
        suffixIcon={
          <IconWrapper>
            <Icon variant='arrowDown' />
          </IconWrapper>
        }
        placeholder='Сортировка'
        options={options}
        value={sortValue}
        onSelect={onSelect}
      ></Select>
      <div className='floating-label'>Сортировка</div>
    </SelectWithLabel>
  );
};

export default SortSelect;
